import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { AppleDevice, Device, InstalledAppleApplication } from '@era/locations-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { EditDeviceNameModalComponent } from '../../../devices/components/edit-device-name-modal/edit-device-name-modal.component';
import { AppleApplicationLockChanged } from '../../../devices/models/apple-application-lock-changed.model';
import { AppleDeviceDesiredNameChanged } from '../../../devices/models/apple-device-desired-name-changed.model';

@Component({
  selector: 'era-apple-device-ui',
  templateUrl: './apple-device.component.html',
  styleUrls: ['./apple-device.component.scss'],
  imports: [FaIconComponent],
})
export class AppleDeviceComponent implements OnDestroy, OnChanges {
  @Input() public appleDevice: AppleDevice;
  @Input() public device: Device;
  @Input() public isAtLatestAllowedOsVersion = true;

  public displayDesiredName: boolean;

  @Output() public readonly applicationLockChange: EventEmitter<AppleApplicationLockChanged> =
    new EventEmitter<AppleApplicationLockChanged>();

  @Output() public readonly desiredNameChange: EventEmitter<AppleDeviceDesiredNameChanged> =
    new EventEmitter<AppleDeviceDesiredNameChanged>();

  @Output() public readonly updateDeviceEvent: EventEmitter<string> = new EventEmitter<string>();

  private modalSubscriptions?: Subscription;

  constructor(private modalService: NgbModal) {}

  ngOnChanges(): void {
    this.recalculate();
  }

  recalculate() {
    if (!this.device) {
      this.displayDesiredName = false;
      return;
    }
    this.displayDesiredName =
      this.device.deviceName != undefined &&
      this.device.desiredName != undefined &&
      !this.device.deviceName.endsWith(` ${this.device.desiredName}`);
  }

  public callUpdate(udid: string) {
    this.updateDeviceEvent.emit(udid);
  }

  public callLock(udid: string, application: InstalledAppleApplication) {
    this.applicationLockChange.emit(new AppleApplicationLockChanged(udid, application.identifier, true));
  }

  public callUnlock(udid: string, application: InstalledAppleApplication) {
    this.applicationLockChange.emit(new AppleApplicationLockChanged(udid, application.identifier, false));
  }

  public editName() {
    if (!this.device) {
      return;
    }
    const modalRef = this.modalService.open(EditDeviceNameModalComponent);
    const instance = modalRef.componentInstance as EditDeviceNameModalComponent;
    instance.initialName = this.device.desiredName;

    this.modalSubscriptions = modalRef.closed.subscribe((x) => {
      this.desiredNameChange.emit(new AppleDeviceDesiredNameChanged(this.device.deviceId, x.newName));
      this.unsubscribe();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private unsubscribe() {
    if (this.modalSubscriptions !== undefined) {
      this.modalSubscriptions.unsubscribe();
    }
  }
}
